/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CommunityItemMinimal } from '../../models/community-item-minimal';

export interface CommunityControllerCreate$Params {
      body: {
'picture'?: Blob;
'name'?: string;
'text'?: string;
'public'?: boolean;
'tags'?: string[];
}
}

export function communityControllerCreate(http: HttpClient, rootUrl: string, params: CommunityControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityItemMinimal;
}>> {
  const rb = new RequestBuilder(rootUrl, communityControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CommunityItemMinimal;
      }>;
    })
  );
}

communityControllerCreate.PATH = '/community';
